import Module from "../../../../framework/core/mvvm/module_base";
import K9TableModel from "./k9_talbe_model";
import K9TableView from "./k9_talbe_View";
import K9SeatEntity from "./k9_seat_entity";
import { NetMsgK9 } from "../../net/net_msg_data_map_k9";
import { K9Proto } from "../../net/proto/proto_k9_game";
import { K9 } from "./k9_data";
import K9SeatEntityBase from "./k9_seat_entity_base";
import { K9SeatCfg } from "./component/k9_state_config";
import ModelData from "../../../public/model_data";
import GameServer from "../../../hall/server/gameserver/game_server";
import { K9Room } from "../../net/proto/proto_k9_room";
import ModuleManager from "../../../../framework/core/module_manager";
import K9SeatBank from "./k9_seat_bank";
import LanguageManager from "../../../../manager/language_manager";
import K9Help from "./component/k9_help";
import UserDataManager from "../../../../manager/user_manager";
import TableBaseModule from "../../../table/module/table_base/table_base_module";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9TableModuleBase extends TableBaseModule<K9TableView,K9TableModel> {

    //下标 即viewID
    protected seatEntitys:K9SeatEntityBase[] = [];

    protected bankEntity:K9SeatBank = null;//庄家实体

    protected isInit:boolean = false;

    protected tableNumb:number = 0;

    //玩家真实id//上庄的时候也保持一个id
    protected realSeatId:number = 0;

    protected seatNode:cc.Node[];

    onInit(){
    }

    onShow(){
        this.model.init(GameServer.instance.netClient)
        this.model.clearMsgEvent()
        this.registerNetMessage();
    }

    protected initGame(proto:K9Proto.GameInfo){
        if (!this.isInit) {
            this.tableNumb = this.view.seatTarget.childrenCount;
            this.view.setSeatNumb();
            this.createSeatEntity(this.tableNumb);
            //this.createSeatNode(this.tableNumb);
            this.view.isShowBanker(false);
            this.isInit = true;
        }
    }

    protected registerNetMessage(){
        this.model.subscibeMsgEvent<K9Proto.IGameInfo>(NetMsgK9.GameInfo,this.onRevGameInfo.bind(this),true);

        this.model.subscibeMsgEvent<K9Room.ILeaveBroadcast>(NetMsgK9.LeaveRoomNotify,this.leaveBroadcast.bind(this),true)

        this.model.subscibeMsgEvent<K9Room.ILeaveRsp>(NetMsgK9.LeaveRoom, this.leaveRoomRsp.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.ITimeoutNotify>(NetMsgK9.TimeoutNotify,this.timeoutNotify.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IBankerQueueNotify>(NetMsgK9.BankerQueueNotify,this.bankerQueueNotify.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IBankerRsp>(NetMsgK9.Banker,this.bankerRsp.bind(this),true)

        this.model.subscibeMsgEvent<K9Room.IEnterBroadcast>(NetMsgK9.EnterBroadcast,this.onNetMsgEnterNotify.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IBetRsp>(NetMsgK9.BetReq,this.onBetRsp.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IBankerNotify>(NetMsgK9.BankerNotify,this.bankerNotify.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IPreopenCardNotify>(NetMsgK9.PreopenCardNotify,this.preopenCardNotify.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IBetNotify>(NetMsgK9.BetNotify,this.betNotify.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IMoreCardRsp>(NetMsgK9.MoreCardReq,this.moreCardRsp.bind(this),true)

        this.model.subscibeMsgEvent<K9Proto.IMoreCardNotify>(NetMsgK9.MoreCardNotify,this.moreCardNotify.bind(this),true)
        
        this.model.subscibeMsgEvent<K9Proto.IDealCardNotify>(NetMsgK9.DealCardNotify,this.dealCardNotify.bind(this),true)
        
        this.model.subscibeMsgEvent<K9Proto.IGameSettle>(NetMsgK9.GameSettle,this.gameSettle.bind(this),true)

        this.model.subscibeMsgEvent<K9Room.IStartBroadcast>(NetMsgK9.StartBroadcast,this.startBroadcast.bind(this),true)
    }


    protected onRevGameInfo(proto:K9Proto.GameInfo){
        this.initGame(proto)

        let meBanker = this.isRole(proto.bankerId)
      
        if (meBanker) {//我坐庄
            this.realSeatId = proto.bankerSeatId;//之前的座位id 计算位置用
        }
    
        this.initTableSeatData(proto.seatList);

        //初始化座位数据
        this.initPlayer(proto);

        this.model.commonData = new K9.CommonData();
        this.model.commonData.banker_queue = proto.bankerQueue;
        this.model.commonData.bankId = proto.bankerId;
        this.model.commonData.event = 0;
        this.model.commonData.ackId = 0;
        if (this.model.bankData) {
            this.model.bankData.banker_loop_cnt = proto.bankerLoopCnt;
        }

        for (let entity of this.seatEntitys) {
            entity.onLoad();
        } 
        this.bankEntity.onLoad();
        
        for (let seatData of this.model.seatData) {
            let entity = this.getEntity(seatData.seat_pos);
            entity.onShow(seatData)
        }
        
        this.bankEntity.onShow(this.model.bankData);
    }

    protected startBroadcast(proto:K9Room.IStartBroadcast){

    }

    protected dealCardNotify(proto:K9Proto.IDealCardNotify){
        for (let seat of proto.seatList) {
            if (seat.seatId != 0) {//庄家单独处理
                this.model.changeSeatInfo(seat);
            }else{
                this.model.changeBankData(seat);
            }
        }
    }

    protected gameSettle(proto:K9Proto.IGameSettle){
        for (let seat of proto.seatList) {
            UserDataManager.setUserGameTableCurrency(seat.playerId,seat.coinBalance)
            if (seat.seatId != 0) {//庄家单独处理
                this.model.changeSeatInfo(seat);
            }else{
                this.model.changeBankData(seat);
            }
        }
    }

    //要牌无需排序，涉及节点排序
    protected moreCardNotify(proto:K9Proto.IMoreCardNotify){
        let seatData = this.findSeatData(proto.seatId);
        if (seatData) {
            if (!proto.noMoreCard) {
                seatData.cards = seatData.cards.concat(proto.card);
                seatData.card_type = proto.cardType;
                seatData.card_point = proto.cardPoint;
                seatData.win_rate = proto.winRate;
            }
            seatData.state = K9.PlayerState.Operator
        }else{
            if (!proto.noMoreCard) {
                this.model.bankData.cards = this.model.bankData.cards.concat(proto.card);
                this.model.bankData.card_point = proto.cardPoint;
                this.model.bankData.card_type = proto.cardType;
                this.model.bankData.win_rate  = proto.winRate;
            }
            this.model.bankData.state = K9.PlayerState.Operator
        }
    }

    protected moreCardRsp(proto:K9Proto.IMoreCardRsp){

    }

    protected betNotify(proto:K9Proto.IBetNotify){
        if (proto.seatId != 0) {
            let data = this.findSeatData(proto.seatId);
            if (data) {
                data.bet_coin = proto.betCoin;
                data.coin_balance = proto.coinBalance;
                data.state = K9.PlayerState.CheckBet;//下注了
                UserDataManager.setUserGameTableCurrency(data.player_id,proto.coinBalance)
            }
        }else{
            let bankData = this.model.bankData;
            bankData.bet_coin = proto.betCoin;
            bankData.coin_balance = proto.coinBalance;
            bankData.state = K9.PlayerState.CheckBet;
            UserDataManager.setUserGameTableCurrency(bankData.player_id,proto.coinBalance)
        }

    }

    //预开牌
    protected preopenCardNotify(proto:K9Proto.IPreopenCardNotify){
        for (let seat of proto.seatList) {
            if (seat.seatId != 0) {//庄家单独处理
                this.model.changeSeatInfo(seat);
            }else{
                this.model.changeBankData(seat);
            }
        }
    }

    protected initTableSeatData(seatList:K9Proto.ISeatInfo[]){
        this.model.reset()
        
        for (let seatData of seatList) {
            UserDataManager.setUserGameTableCurrency(seatData.playerId,seatData.coinBalance)
            if (seatData.seatId != 0) {
                if (this.isRole(seatData.playerId)) {
                    this.realSeatId = seatData.seatId;
                }
                this.model.pushSeatInfo(seatData);
            }else{
                this.model.bankData = new K9.SeatBankData();//banker数据
                let data = this.model.initSeatData(seatData);
                this.model.bankData = <K9.SeatBankData>data;
            }   
        }
    }

    //定庄通知
    protected bankerNotify(proto:K9Proto.IBankerNotify){
        this.initTableSeatData(proto.seatList)
        this.model.commonData.banker_queue = proto.bankerQueue;
        this.model.commonData.bankId = proto.id;
        this.model.bankData.banker_loop_cnt = proto.bankerLoopCnt
    }

    protected onBetRsp(proto:K9Proto.IBetReq){

    }

    //用户加入
    protected onNetMsgEnterNotify(proto:K9Room.IEnterBroadcast){
        let info = proto.posInfo;
        let seatInfo:K9Proto.ISeatInfo = {
            seatId:info.posIndex,
            playerId:info.playerId,
            cards:[],
            coinBalance:info.coinBalance,
            state:0,
            userJson:proto.userJson,
            betCoin:0,
        }
        let data = this.model.pushSeatInfo(seatInfo);
        let entity = this.getEntity(info.posIndex);
        if (entity) {
            entity.onShow(data)
        }
        UserDataManager.setUserGameTableCurrency(seatInfo.playerId,info.coinBalance)
    }

    protected bankerRsp(proto:K9Proto.IBankerRsp){
        if (proto.errNo == 0) {
            let data = this.getMySeatData();
            if (proto.isReq) {//上庄
                ModuleManager.instance.toast(LanguageManager.t('k9_req_banker',true));
            }
            if (data && data.state != K9.PlayerState.NoInGame) {//游戏中
                if (!proto.isReq && this.meIsBank()) {
                    ModuleManager.instance.toast(LanguageManager.t('banker_close',true));
                }
            }
        }
   
    }

    protected bankerQueueNotify(proto:K9Proto.IBankerQueueNotify){
        this.model.commonData.banker_queue = proto.bankerQueue;
    }

    protected leaveRoomRsp(proto:K9Room.ILeaveRsp){

    }

    protected leaveBroadcast(proto:K9Room.ILeaveBroadcast){
        let isMe = this.isRole(proto.playerId)
        if (!isMe) {
            if (this.isBank(proto.playerId)) {//庄家离开
                this.model.bankData = null;
            }else{
                this.model.removeSeatInfo(proto.playerId);
            }
        }

        if (proto.reason != undefined) {
            if (proto.reason != 0) {
                if (isMe) {
                    ModuleManager.instance.toastKey("jd_leave" + proto.reason)
                }
            }
        }
    }

    protected timeoutNotify(proto:K9Proto.ITimeoutNotify){
        if (proto.event == 888) {
            if (this.model.commonData) {
                this.model.commonData.ackId = proto.param;
            }            
        }
        if (this.model.commonData) {
            this.model.commonData.event = proto.event;
        }

    }

    protected getEntitysBySort():K9SeatEntityBase[]{
        let seatEntity:K9SeatEntityBase[] = [];
        for (let idx = 0; idx < this.model.seatData.length; idx++) {
            let data = this.model.seatData[idx];
            if (data) {
                if (data.state != K9.PlayerState.NoInGame
                    && data.state != K9.PlayerState.BeginOpen) {
                    let entity = this.getEntity(data.seat_pos);
                    if (entity) {
                        seatEntity.push(entity);
                    }
                }
            }
        }

        seatEntity.sort(function(a:K9SeatEntityBase,b:K9SeatEntityBase){
            return a.seatPos-b.seatPos;
        })

        seatEntity.unshift(this.bankEntity);

        return seatEntity;
    }

    //pos - viewid 0,1,2,3..
    protected getEntity(v:number,ispos:boolean = true){
        if (ispos) {
            let viewid = this.getViewID(v);
            if (viewid != null) {
                let entity = this.seatEntitys[viewid];
                return entity;
            }
        }else{
           return this.seatEntitys[v];
        }
        return null;
    }

    meIsBank(){
        return this.model.bankData && this.isRole(this.model.bankData.player_id);
    }

    isBank(playerId:number){
        return this.model.commonData.bankId == playerId;
    }

    onRestart(){
        
    }

    getBankData():K9.SeatBankData{
        return this.model.bankData;
    }

    protected initPlayer(proto:K9Proto.GameInfo){
        this.seatEntitys[0].seatPos = this.realSeatId;
        this.refreshPos(0);
        //计算其他座位基础设置
        for (let i = 1; i < this.tableNumb; i++) {
            let seatEntity = this.seatEntitys[i];
            seatEntity.seatPos = this.seatEntitys[i-1].seatPos % this.tableNumb + 1;
            this.refreshPos(i);
        }
    }

    isRole(playerID:number){
        return playerID == ModelData.instance.roleData.id;
    }

    findSeatData(v:number,ispos:boolean = true):K9.SeatData{
        return this.model.findSeatData(v,ispos);
    }

    sendAck(){
        this.model.send_Ack();
    }

    getMySeatData():K9.SeatData{
        if (this.model.bankData && this.isRole(this.model.bankData.player_id)) {
            return this.model.bankData;
        }
        return this.findSeatData(Number(ModelData.instance.roleData.id),false);
    }

    getMyEntity(){
        let data = this.model.bankData;
        if (data && this.isRole(data.player_id)) {
            return this.bankEntity;
        }
        return this.getEntity(0,false);
    }

    createSeatEntity(num:number){
        for (let i = 0; i < num; i++) {
            let seatEntity = new K9SeatEntity();
            seatEntity.parent = this;
            seatEntity.tableview = this.view;
            this.seatEntitys[i] = seatEntity;
            seatEntity.create(this.view.seatPrefab,this.view.seatRoot);     
            let pos = this.view.getSeatCfg(i);
            seatEntity.setPosition(pos.getPosition());
        }
        this.bankEntity = new K9SeatBank();
        this.bankEntity.parent = this;
        this.bankEntity.tableview = this.view;
        this.bankEntity.initBank(this.view.bankerNode,this);
    
    }

    //创建可点击的座位
    createSeatNode(num:number){
        //创建座位
        this.seatNode = this.seatNode || [];
        for (let i = 0; i < num; i++) {
            let seatNode = this.view.addSeat(i);
            this.seatNode[i] = seatNode;
            seatNode.active = false;
        }
    }

    updateTableState(state:number){
        
        if (state == 2) {//下注阶段
            this.view.updateOperatorState(1,this.getMySeatData());
        }else if (state == 5) {//要牌阶段
            this.view.updateOperatorState(0,this.getMySeatData());
        }else{
            this.view.updateOperatorState(2,this.getMySeatData());
        }

    }

    //时针
    protected playerSeatViewId(viewId:number){
        if (viewId == 0) {
            return;
        }
        let count = this.tableNumb
        for (let i = 0; i < count; i++) {
            let pos = i;
            let next = (i+ count -1) % count;
            let moveArry = [];
            for (let j = 0; j < viewId; j++) {
                pos = next;
                let cfg = this.view.getSeatCfg(pos);
                if (cfg) {
                    let action = cc.moveTo(0.1,cfg.getPosition());
                    moveArry.push(action)
                }
                next = (next + count -1) % count;
            }
            this.seatToPos(i,pos);
            if (moveArry.length > 0) {
                let sequence;
                if (moveArry.length == 1) {
                    sequence = moveArry[0];
                }else{
                    sequence = cc.sequence(moveArry);
                }
                this.seatEntitys[i].runAction(sequence);
            }
            this.seatEntitys[i].sortID = pos;
        }

        //排序
        this.seatEntitys.sort(function(a:K9SeatEntityBase,b:K9SeatEntityBase){
            return a.sortID-b.sortID;
        })
        
    }

    protected getViewID(serverSeatId:number):number{
        for (let i = 0; i < this.seatEntitys.length; i++) {
            let entity = this.seatEntitys[i];
            if (entity.seatPos == serverSeatId) {
                return i;
            }
        }
        return null;
    }

    protected playerDown(seatPos:number){
        //更新布局
        let viewid = this.getViewID(seatPos);
        if (viewid != null) {
            this.seatToPos(seatPos,seatPos);
            let entity = this.seatEntitys[viewid];
            if (entity) {
                entity.playerDown(viewid);
            }
        }
    }

    getPotNode():cc.Node{
        return this.view.potNode;
    }

    //做到某个位置
    protected seatToPos(curViewid:number,toviewid:number){
        let seatInfo = this.view.getSeatCfg(toviewid);
        let seateEntity = this.seatEntitys[curViewid];
        if (seatInfo && seateEntity) {
            seatInfo.refreshNodeInfo((cfg:K9SeatCfg)=>{
                seateEntity.updateSeatInfo(cfg);
            })
        }
    }

    protected refreshPos(viewid:number){
        let seatEntity = this.seatEntitys[viewid];
        let seatInfo = this.view.getSeatCfg(viewid);
        if (seatEntity && seatInfo) {
            let pos = seatInfo.getPosition();
            seatEntity.setPosition(pos);
        }
        //更新布局
        this.seatToPos(viewid,viewid);
    }

    protected isInQueue(){
        let bankerqueue = this.model.commonData.banker_queue;
        for (let i = 0; i < bankerqueue.length; i++) {
            let banker = bankerqueue[i];
            if (this.isRole(banker)) {
                return true;
            }
        }
        return false;
    }

    protected getBankers():any[]{
        let data = [];
        let bankerqueue = this.model.commonData.banker_queue;
        for (let i = 0; i < bankerqueue.length; i++) {
            let bankid = bankerqueue[i];
            let bankData = this.findSeatData(bankid,false);
            if (bankData) {
                let banker = {
                    id :bankid,
                    round:0,
                    balance:bankData.coin_balance,
                    userData:bankData.userJson,
                };
                data.push(banker);
            }
        }
        return data;
    }
}
